"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import type { CatalogStory } from "@/lib/actions/story-actions";
import { orderByRecommendation } from "@/lib/recommendations/order";
import { StoryGrid } from "./story-grid";
export function BrowseAllResults(t0) {
  const $ = _c(11);
  const {
    stories
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [order, setOrder] = useState(t1);
  let t2;
  let t3;
  if ($[1] !== stories) {
    t2 = () => {
      const frame = requestAnimationFrame(() => {
        const ids = stories.map(_temp);
        for (let i = ids.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          const [t4, t5] = [ids[j], ids[i]];
          ids[i] = t4;
          ids[j] = t5;
        }
        setOrder(ids);
      });
      return () => cancelAnimationFrame(frame);
    };
    t3 = [stories];
    $[1] = stories;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  if (order.length !== stories.length) {
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <p role="status" className="text-sm text-muted-foreground">Shuffling stories…</p>;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    return t4;
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className="text-sm text-muted-foreground">All public stories, shuffled each time you visit.</p>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== order || $[7] !== stories) {
    t5 = orderByRecommendation(stories, order);
    $[6] = order;
    $[7] = stories;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <>{t4}<StoryGrid stories={t5} title="Browse all" hideSort={true} /></>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}
function _temp(story) {
  return story.id;
}